import { alpha, ThemeOptions } from '@mui/material';

// tslint:disable:quotemark
// tslint:disable:interface-name
declare module '@mui/material/Checkbox' {
  interface CheckboxPropsSizeOverrides {
    large: true;
  }
}

export const MuiCheckbox: ThemeOptions['components']['MuiCheckbox'] = {
  defaultProps: { disableFocusRipple: true },

  styleOverrides: {
    root: ({ theme }) => ({
      padding: '4px',
      margin: '4px',
      '&.MuiCheckbox-root': {
        color: theme.palette.divider,
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.08)
        },
        '&.Mui-checked': {
          color: theme.palette.primary.main
        },
        '&.Mui-disabled': {
          color: theme.palette.action.disabled
        },
        // Not using tokens for these because they must be these particular sizes in rem
        // (can't just use lineheight or you will have really tiny checkboxes because those are just numbers)
        '&.MuiCheckbox-sizeSmall .MuiSvgIcon-root': {
          fontSize: '1.167rem'
        },
        '&.MuiCheckbox-sizeMedium .MuiSvgIcon-root': {
          fontSize: '1.5rem'
        },
        '&.MuiCheckbox-sizeLarge .MuiSvgIcon-root': {
          fontSize: '1.667rem'
        },
        '&.MuiCheckbox-colorError': {
          color: theme.palette.error.main,
          '&:hover': {
            backgroundColor: alpha(theme.palette.error.main, 0.08)
          }
        },
        '&.Mui-focusVisible, &:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: -2
        },
        '&.Mui-hover, &:hover': {
          backgroundColor: theme.palette.action.hover
        }
      }
    })
  },
  variants: [
    {
      props: { size: 'large' },
      style: () => ({
        '&.MuiCheckbox-root': {}
      })
    }
  ]
};
